// Google Play pre-registration link. UTM tracking is added per placement so we
// can see in the admin dashboard which pages/channels drive pre-registrations.
const PLAY_STORE_ID = "app.emergent.rentalmatchnl634308bd";

export function playStoreUrl(placement = "site") {
  const params = new URLSearchParams({
    id: PLAY_STORE_ID,
    utm_source: "woningalert",
    utm_medium: "web",
    utm_campaign: "preregistration",
    utm_content: placement,
  });
  return `https://play.google.com/store/apps/details?${params.toString()}`;
}
